import { createStore } from 'redux';
// import logger from 'redux-logger';

import reducers from './reducers';
// import sagas from './sagas';

// const middleware = applyMiddleware(logger);

const store = createStore(reducers);
export default store;
